<template>
  <div class="tile">

    <details>
      <summary>Datenschutzerklärung & Impressum</summary>
      <h2>Datenschutzerklärung</h2>
      Auf dieser Website werden unter Einsatz der Webanalysedienst-Software Matomo (www.matomo.org), einem Dienst
      des Anbieters InnoCraft Ltd., 150 Willis St, 6011 Wellington, Neuseeland, („Mataomo“) auf Basis unseres
      berechtigten Interesses an der statistischen Analyse des Nutzerverhaltens zu Optimierungs- und
      Marketingzwecken gemäß Art. 6 Abs. 1 lit. f DSGVO Daten gesammelt und gespeichert. Aus diesen Daten können
      zum selben Zweck pseudonymisierte Nutzungsprofile erstellt und ausgewertet werden. Hierzu können Cookies
      eingesetzt werden. Bei Cookies handelt es sich um kleine Textdateien, die lokal im Zwischenspeicher des
      Internet-Browsers des Seitenbesuchers gespeichert werden. Die Cookies ermöglichen unter anderem die
      Wiedererkennung des Internet-Browsers. Die mit der Matomo-Technologie erhobenen Daten (einschließlich Ihrer
      pseudonymisierten IP-Adresse) werden auf unseren Servern verarbeitet. .
      Die durch das Cookie erzeugten Informationen im pseudonymen Nutzerprofil werden nicht dazu benutzt, den
      Besucher dieser Website persönlich zu identifizieren und nicht mit personenbezogenen Daten über den Träger
      des Pseudonyms zusammengeführt.
      Wenn Sie mit der Speicherung und Auswertung dieser Daten aus Ihrem Besuch nicht einverstanden sind, dann
      können Sie der Speicherung und Nutzung nachfolgend per Mausklick jederzeit widersprechen. In diesem Fall
      wird in Ihrem Browser ein sog. Opt-Out-Cookie abgelegt, was zur Folge hat, dass Matomo keinerlei
      Sitzungsdaten erhebt. Bitte beachten Sie, dass die vollständige Löschung Ihrer Cookies zur Folge hat, dass
      auch das Opt-Out-Cookie gelöscht wird und ggf. von Ihnen erneut aktiviert werden muss.
      <br>
      <iframe
        style="border: 0; height: 200px; width: 600px;"
        src="https://matomo.onatcer.com/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=&fontSize=&fontFamily="
      ></iframe>
      <h2>Impressum</h2>
      <p>Gregor Vostrak</p>
      <p>Unternehmensgegenstand: Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik</p>
      <p>UID-Nr.: ATU73800728</p>
      <p>Sitz: Türkenstraße 19/1B, 1090 Wien, Österreich</p>
      <p>Mail: gregor /at/ vostrak /dot/ at</p>
      <p>Telefonnummer: /plus/ 436801111642</p>

    </details>
  </div>
</template>

<script>

  export default {
    name: 'Datenschutzerklaerung',
    components: {},
    props: [
      'data'
    ],
    computed: {},
    methods: {
      open() {
        this.$modal.show('datenschutz', {height: 'auto'});
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  summary, summary:active {
    outline: 0;
  }

  summary::-webkit-details-marker {
    color: #C86DD7;
  }

  details {
    padding: 20px;
    text-align: left;
  }

  h2 {
    font-weight: bold;
    margin: 10px 0;
  }

  a {
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// Datenschutzerklaerung.vue?0edd09d2